module.exports = __webpack_public_path__ + "img/twitter.f7f2f247.svg";